// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2YL9D","legacyBtn":"MutateMid_legacyBtn__1avu5"};